import scrollMonitor from '../../lib/scrollMonitor/scrollMonitor.js';

class Numberscroll {
  constructor(el) {
    if(!el) return false;
    this.el = el;
    this.value = this.el.innerHTML.replace(/,/g, "");
    this.decimal = 0;
    this.minDigit = 1;
    this.watcher = scrollMonitor.create(this.el);
    this.watcher.enterViewport(function() {
      $({ counter: 0 }).animate({ counter: this.value }, {
        duration: 2000,
        easing: 'easeOutExpo',
        step: function (value) {
		      window.requestAnimationFrame(function(){
            this.el.innerHTML = this.prettify(value);
          }.bind(this));
        }.bind(this)
      });
    }.bind(this));
    this.watcher.exitViewport(function() {
      //console.log( 'I have left the viewport' );
    });
  }
  prettify(number){
    var pre = '';
    var rounded = this.round(number, this.decimal);
    var commas = rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var string = pre + commas;
    if(typeof this.minDigit !== typeof undefined || this.minDigit !== false) {
      for(var i = string.length; i < this.minDigit; i++) {
        pre += '0';
      }
      string = pre + string;
    }
    return string;
  }
  round(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
  }
}

export default function () {
  var numbers = document.querySelectorAll('[data-numberscroll]');

  Array.from(numbers).forEach(function(item, index) {
    var number = new Numberscroll(item);
  })
}



// WEBPACK FOOTER //
// ./public/javascripts/modules/numberscroll.js